<template>
  <div class="page-layout" :style="{'padding-top': show ? '90px' : '60px'}">
    <div class="page-header-wrapper">
        <el-alert v-if="show" :closable="true" effect="dark" center @close="show=false"
            type="warning">
            <slot name="title">
                <span style="font-size: 18px;font-weight: bold;" v-html="warningHtml">
                    
                </span>
            </slot>

        </el-alert>

      <PageHeader></PageHeader>
    </div>
    
    <router-view class="sub-page" />
  </div>
</template>

<script>
import PageHeader from '@/components/page-header'
export default {
  components: {
    PageHeader
  },
  data() {
    return {
        authType: null,
        managers: [],
        loading: false,
        show: false,
        warningHtml: ''
    }
  },
  created() {
    this.init();
},
  methods: {
    init() {
        this.loading = true;
        this.authType = null;
        this.show = false;
        this.warningHtml = '';

        this.$API.getAuthType().then((res) => {
            this.loading = false;

            this.show = res.data.showWarning;
            this.authType = res.data.authType;
            this.managers = res.data.managers;
            this.warningHtml = res.data.warningHtml;
            
            //if (this.authType != 'admin') {
            //    this.show = true;
            //}
        }).catch((err) => {
            this.loading = false;
        });
    }
  }
}
</script>

<style scoped>
.page-layout {
  height: 100%;
  padding-top: 60px;
  overflow: auto;
  background: rgb(240, 243, 244);
  width: 100%;
}



.sub-page {
  position: relative;
  height: 100%;
  max-width: 1440px;
  min-width: 1280px;
  width: 100%;
  padding: 20px 80px;
}
.page-header-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

@media screen and (min-width: 1280px) {
  .page-layout {
    justify-content: center;
    display: flex;
  }

  .sub-page {
    position: relative;
    height: 100%;
    max-width: 1440px;
    min-width: 1280px;
    width: 100%;
    padding: 20px 40px;
    }
}
</style>
